/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { propTypes } from 'react-bootstrap/esm/Image';
import { Auth } from 'aws-amplify';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { KTSVG } from '../../../../../_metronic/helpers';
import { useAuth } from '../../../../modules/auth';

type Props = {
    className: string,
    doctors: any,
    getAllDoctor: any
}

const DoctorTable: React.FC<Props> = ({ className, doctors, getAllDoctor }) => {

    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState(null);
    const [edit, setEdit] = useState(false);
    const { currentUser } = useAuth();


    useEffect(() => {
        console.log(doctors)
    },[])


    const toggleShow = (userId: any) => {

        setEdit(false);
        if (userId !== 0) {
            setEdit(true);
            doctors.map((user: any) => {
                if (userId === user.id) {
                    setData(user);
                }
            });

        }

        //console.log('toggleShow ' + userId)
        setShowModal(pre => !pre);

        if (showModal) {
            getAllDoctor();
        }
    }

    const deleteUser = async (userId: any) => {
        //delete user

        try {

            confirmAlert({
                title: 'Confirm',
                message: 'Are you sure, you want to delete?',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: async () => {

                            const auth = await Auth.currentSession();
                            const token = auth.getAccessToken().getJwtToken();

                            await fetch(process.env.REACT_APP_API_URL_BACKEND + '/admin/user/',
                                {
                                    method: 'DELETE',
                                    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                                    body: JSON.stringify({ 'user_id': userId })
                                });

                            getAllDoctor();
                        }
                    },
                    {
                        label: 'No',
                        onClick: () => { }
                    }
                ]
            });

        }
        catch (error) {
            console.log(error);
        }


    }

    return (
        <>
            <div className={`card ${className}`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-3 mb-1'>Users</span>
                    </h3>
                    <div className='card-toolbar'>
                        {/* <button onClick={() => toggleShow(0)} className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add User
          </button> */}
                    </div>
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                        {/* begin::Table */}
                        <table className='table align-middle gs-0 gy-4'>
                            {/* begin::Table head */}
                            <thead>
                                <tr className='fw-bold text-muted bg-light'>
                                    <th className='ps-4 min-w-100px rounded-start'>Name</th>
                                    {
                                        currentUser.userSession.user.role_id > 0 && currentUser.userSession.user.role_id < 3 ? (
                                            <th className='ps-4 min-w-100px rounded-start'>Organization</th>
                                        ) : null
                                    }
                                    <th className='ps-4 min-w-100px rounded-start'>Branch</th>
                                    <th className='ps-4 min-w-100px rounded-start'>Department</th>
                                    <th className='min-w-200px text-end rounded-end'></th>
                                </tr>
                            </thead>
                            {/* end::Table head */}
                            {/* begin::Table body */}
                            <tbody>
                                {doctors.map((doctor: any) => (
                                    <tr key={`doctor-${doctor.id}`}>
                                        <td><span className='text-dark fw-bold mb-1 fs-6'>{doctor.profile.first_name} {doctor.profile.last_name}</span></td>
                                        {
                                            currentUser.userSession.user.role_id > 0 && currentUser.userSession.user.role_id < 3 ? (
                                                <td><span className='text-dark fw-bold mb-1 fs-6'>{doctor.organization.name}</span></td>
                                            ) : null
                                        }

                                        <td><span className='text-dark fw-bold mb-1 fs-6'>{doctor.branch.name}</span></td>
                                        <td><span className='text-dark fw-bold mb-1 fs-6'>{doctor.department.name}</span></td>
                                        <td className='text-end'>
                                            <a href='#' onClick={() => toggleShow(doctor.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                                                <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                                            </a>
                                            <a href='#' onClick={() => deleteUser(doctor.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                                                <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                                            </a>
                                        </td>
                                    </tr>
                                )
                                )}


                            </tbody>
                            {/* end::Table body */}
                        </table>
                        {/* end::Table */}
                    </div>
                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
            {
                // showModal ? <UserAddModal toggleShow={toggleShow} roles={roles} isUpdate={edit} itemToEdit={data} /> : null
            }
        </>
    )
}

export { DoctorTable }
